module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_maedori_01@3x-a10140392e08cd0a22f5128950824ada.webp";